import { render, staticRenderFns } from "./CardProjectV2.vue?vue&type=template&id=a0ea2e80&scoped=true"
import script from "./CardProjectV2.vue?vue&type=script&lang=js"
export * from "./CardProjectV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ea2e80",
  null
  
)

export default component.exports